import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderNumberRequest, PricingItem, SelectedMsisdn } from '../pricing-numbers/pricing-numbers';
import { FormGroupWrapper } from '../../lead-generation/shared/domain/FormGroupWrapper';
import { Location } from '@angular/common';
import { markFormAsTouched } from '../../lead-generation/shared/reactive-forms/forEachElementInForm';
import { AccountSettingsService } from '../../my-account/account-settings.service';
import { Observable } from 'rxjs';
import { Card, CardMetadata } from '../../shared/models/plans';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { OrderInitialNumberAction, OrderNumberAction } from '../pricing-numbers/pricing-numbers.action';

@Component({
  selector: 'cc-get-number-final-step',
  templateUrl: './get-number-final-step.component.html',
  styleUrls: ['./get-number-final-step.component.scss']
})
export class GetNumberFinalStepComponent implements OnInit {
  public pricing: PricingItem;
  public selectedMsisdn: SelectedMsisdn | undefined;
  public labelForm: FormGroupWrapper = { form: null };
  public initialSteps = false;
  public card$: Observable<Card>;
  public cardMetadata$: Observable<CardMetadata>;
  public isLoading = false;

  constructor(
    private accountSettingsService: AccountSettingsService,
    private route: ActivatedRoute,
    private amplitudeService: AmplitudeService,
    private location: Location,
    private store: Store<IState>
  ) {}

  ngOnInit() {
    this.initialSteps = window.location.href.includes('get-first-new-number');
    this.pricing = this.route.snapshot.data['pricing'];
    const { selectedMsisdnId, selectedNumber } = this.route.snapshot.queryParams;
    if (selectedMsisdnId && selectedNumber) {
      this.selectedMsisdn = { id: selectedMsisdnId, number: selectedNumber };
    }
    this.card$ = this.accountSettingsService.getCard();
    this.cardMetadata$ = this.accountSettingsService.getCardMetadata();
    this.logAmplitude('Init');
  }

  finalizeNumberOrdering() {
    if (this.labelForm.form.invalid) {
      this.logAmplitude('Cannot order - invalid form');
      markFormAsTouched(this.labelForm.form);
      return;
    }
    this.isLoading = true;
    this.logAmplitude('Confirm');

    const request: OrderNumberRequest = {
      label: this.labelForm.form.getRawValue().label,
      selectedMsisdn: this.selectedMsisdn,
      pricingId: this.pricing.id
    };
    this.store.dispatch(this.initialSteps ? new OrderInitialNumberAction(request) : new OrderNumberAction(request));
  }

  goBack() {
    this.logAmplitude('Going back');
    this.location.back();
  }

  private logAmplitude(event: string) {
    this.amplitudeService.logEvent(`Panel:Numbers:Final step: ${event}`, {
      initial: this.initialSteps,
      countryCode: this.pricing.countryCode,
      city: this.pricing.city,
      prefix: this.pricing.prefix,
      price: this.pricing.price,
      isRandomNumber: !this.selectedMsisdn,
      msisdn: this.selectedMsisdn && this.selectedMsisdn.number,
      msisdnId: this.selectedMsisdn && this.selectedMsisdn.id
    });
  }
}
